import { PayeeBaseSupportingDocument } from "../types";

export enum TaxDocumentType {
  US_TAX = "us_tax",
  NON_US_TAX = "non_us_tax",
}

export type PayeeVendorTaxDocument = PayeeBaseSupportingDocument & {
  documentType: TaxDocumentType;
};
